import React from 'react'

import {
  Accordion,
  AlignItems,
  Body2,
  BorderStyle,
  Box,
  Color,
  Display,
  FontFamily,
  Heading2,
  Heading3,
  Icon,
  IconVariant,
  JustifyContent,
  Link,
  LinkVariant,
  Text,
} from '@gousto-internal/citrus-react'

import { RichText } from '../../components/RichText'

import type { FaqsFields } from './types'

export type FAQsProps = FaqsFields

function renderAccordionHeader(question: string) {
  return function AccordionHeader(isExpanded: boolean) {
    return (
      <Box
        display={Display.Flex}
        justifyContent={JustifyContent.SpaceBetween}
        alignItems={AlignItems.Center}
      >
        <Heading3 color={Color.White} fontFamily={FontFamily.Bold} size={6}>
          {question}
        </Heading3>

        <Text color={Color.White} size={15}>
          <Icon
            variant={IconVariant.Inherit}
            name={isExpanded ? 'chevron_large_up' : 'chevron_large_down'}
          />
        </Text>
      </Box>
    )
  }
}

export function FAQs({ heading, body }: FAQsProps) {
  const items = body ?? []

  return (
    <Box paddingH={[8, 20]} paddingV={16} display={Display.Block} bg={Color.ColdGrey_600}>
      <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
        <Box maxWidth="1033px" width="100%">
          <Box paddingBottom={2}>
            <Heading2 color={Color.White}>{heading}</Heading2>
          </Box>

          {items.map((item, index) => (
            <Box
              key={item.title}
              borderColor={Color.White}
              borderStyle={BorderStyle.Solid}
              borderBottomWidth={0.5}
              paddingV={5}
              width="100%"
            >
              <Accordion id={`faq-${index}`} title={renderAccordionHeader(item.title)}>
                <Box paddingBottom={2}>
                  <RichText
                    content={item.description}
                    renderParagraph={({ children, key }) => (
                      <Body2 key={key} size={4} color={Color.White}>
                        {children}
                      </Body2>
                    )}
                    renderLink={({ children, href, target, key }) => (
                      <Link
                        key={key}
                        variant={LinkVariant.None}
                        href={href}
                        target={target}
                        style={{ color: 'white', textDecorationLine: 'underline' }}
                      >
                        {children}
                      </Link>
                    )}
                  />
                </Box>
              </Accordion>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
